export const JOBS_FILTERS_INITIAL_VALUES = {
  keywords: '',
  // user: null,
  // job_types: null,
  // location_provinces: null,
  // location_cities: null,
  // is_remote: false,
  // multiple_locations: false,
}
